import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, SearchComponent, WmsTreeComponent } from '@wms/components';
import { BindVariableService } from '@wms/services';

@Component({
  selector: 'wms-bind-page-params',
  standalone: true,
  imports: [
    CommonModule,
    SearchComponent,
    WmsTreeComponent
  ],
  templateUrl: './bind-page-params.component.html',
  styleUrls: ['./bind-page-params.component.less']
})
export class BindPageParamsComponent extends BaseComponent implements OnInit {

  pageParamSearchKey: any;
  bindVariableService: BindVariableService;

  constructor() {
    super();
    this.bindVariableService = inject(BindVariableService);
   }

  searchPageParams($event: any) {
    this.pageParamSearchKey = $event.searchKey;
  }

  ngOnInit(): void {
  }

}
